module.exports = __webpack_public_path__ + "static/media/xz02_grey.26f83db8.png";